var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"title1",domProps:{"innerHTML":_vm._s(_vm.moduleDataSource.info)}}),_c('div',{staticClass:"title2"},[_vm._v(_vm._s(_vm.moduleDataSource.title))]),_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.moduleDataSource.img,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }